import { ValueOf } from '@/types/util';

export const EPointUse = {
  USE: '利用する',
  UNUSED: '利用しない',
  FORCED_USE: '強制利用',
} as const;

export type PointUseKey = keyof typeof EPointUse;
export type PointUseValue = ValueOf<typeof EPointUse>;

export const pointUseKeys = Object.keys(EPointUse) as PointUseKey[];

/** v-select用items */
export const pointUseItems = pointUseKeys
  .map((key) => ({
    title: EPointUse[key],
    value: key,
  }));
